import { epgLocalTimeStampStorage } from '../../storages';

export const onHandleSetUserActive = (userActive: React.MutableRefObject<boolean>) => {
  epgLocalTimeStampStorage.setScrollLeft(window.scrollX);

  if (!userActive.current) {
    userActive.current = true;
  }
};
